
import { type FC } from 'react';
import {
  Swap
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconSwapProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconSwap: FC<UiIconSwapProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Swap}
      {...props}
    />
  );
};
